import { Session } from "@supabase/supabase-js";
import { Basket } from "../types";

export const isNameRequiredCompleted = (basket: Basket): boolean => {
  for (const event of basket.Events) {
    for (const showing of event.Showings) {
      for (const ticket of showing.Items) {
        if (
          ticket.TicketNameRequired &&
          ticket.ShowTicketName &&
          ticket.TicketName === null
        )
          return false;
      }
    }
  }

  return true;
};

// UniqueId of the first ticket in the basket missing a required name, or
// null if every required name is filled in. Used to jump the user to what
// needs attention instead of just disabling the continue button.
export const getFirstIncompleteTicketId = (basket: Basket): number | null => {
  for (const event of basket.Events) {
    for (const showing of event.Showings) {
      for (const ticket of showing.Items) {
        if (
          ticket.TicketNameRequired &&
          ticket.ShowTicketName &&
          ticket.TicketName === null
        )
          return ticket.UniqueId;
      }
    }
  }

  return null;
};

export function removeDups<T>(array: T[]): T[] {
  return [...new Set(array)];
}

export const getRedirectLink = (basket: Basket, session: Session | null) => {
  if (basket?.HasRegoForms) {
    return "/cart/checkout/form";
  }
  if (!session) {
    return "/cart/checkout/sign-in?redirectTo=/cart/checkout/payment";
  }
  return "/cart/checkout/payment";
};
